module.exports = __webpack_public_path__ + "img/蒙版组105@2x.91d34b7c.png";